module.exports = __webpack_public_path__ + "static/apple-launch-750x1294-68114183fd798b493f22dbc324e47d96.png";